export const LIST_ADDONS = `
  query ListAddons($filter: ListAddonsFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    addon {
      listAddons(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items {
          id
          name
          workspace {
            id
            name
          }
          productsCount
          assetsCount
          mediaCount
          createdAt
          updatedAt
        }
      }
    }
  }
`;
